module.exports = __webpack_public_path__ + "img/跳跳.3a455e2c.png";